export class NotificationsConstants {
  static ALL_NOTIFICATIONS: string = 'allNotifications'
  static MY_NOTIFICATIONS: string = 'myNotifications'
  static APP_NOTIFICATIONS: string = 'appNotifications'
}
